import React from "react";
import { IndeterminateCheckbox } from "./IndeterminateCheckbox";

export const SelectionCell = ({ row }) => {
  return <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />;
};
